import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

export function RoomsIntro() {
  const photo = PHOTOS.cabinRow;

  return (
    <section
      className="texture-paper bg-background pb-24 pt-28 sm:pb-28 sm:pt-32 lg:pb-36 lg:pt-36"
      aria-labelledby="rooms-intro-title"
    >
      <div className="mx-auto grid max-w-[1400px] gap-14 px-4 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-20 lg:px-10">
        <MaskReveal className="media-zoom rounded-sm">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes={PHOTO_SIZES.half}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[4/3] w-full rounded-sm object-cover"
          />
        </MaskReveal>

        <div>
          <Reveal>
            <p className="eyebrow text-clay">Amigo Inn &amp; RV Park</p>
            <h2
              id="rooms-intro-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Find the Stay That Fits Your Trip
            </h2>
          </Reveal>

          <Reveal
            delay={0.08}
            className="mt-6 space-y-5 text-base leading-relaxed text-muted-foreground sm:text-lg"
          >
            <p>
              Located in the welcoming community of Zapata, Texas, along U.S. Highway 83, Amigo Inn
              &amp; RV Park provides a convenient place to stay near Falcon Lake and the surrounding
              South Texas region.
            </p>
            <p>
              The area offers a distinctive combination of Texan and Mexican culture, renowned
              fishing opportunities, welcoming local hospitality, and memorable food and traditions.
            </p>
            <p>
              Whether you are visiting for a weekend or settling in for an entire season, our goal
              is to provide a comfortable accommodation and a friendly, down-home atmosphere
              throughout your stay.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
